module.exports = __webpack_public_path__ + "static/img/233.a88d855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200518/233.jpg
// module id = tZqe
// module chunks = 0